import React from 'react';
import { components } from 'react-select';

import { ReactComponent as ChevronDown } from '../../../../assets/images/tabler-icon-chevron-down.svg';
import { ReactComponent as ChevronUp } from '../../../../assets/images/tabler-icon-chevron-up.svg';
import { ReactComponent as ChevronDownDark } from '../../../../assets/images/tabler-icon-chevron-up-dark.svg';

import styles from './DropdownIndicator.module.scss';

export const DropdownIndicator = (props) => {
  const {
    countValue,
    selectProps: { menuIsOpen: isMenuOpen, value },
  } = props;
  const getIcon = () => {
    if (isMenuOpen) {
      return <ChevronUp />;
    }
    if (isMenuOpen && value && value.length > 0) {
      return <ChevronDownDark />;
    }
    return <ChevronDown />;
  };

  return (
    <div className={styles.countContainer}>
      {countValue && <span className={styles.countText}>{countValue}</span>}
      <components.DropdownIndicator {...props}>{getIcon()}</components.DropdownIndicator>
    </div>
  );
};
